module.exports = __webpack_public_path__ + "img/shibie2.869fbba9.svg";